import React from 'react';
import './Projects.css';
import { useNavigate } from 'react-router-dom';

const Projects = () => {
  const navigate = useNavigate()
  return (
    <div className="projects"> <h1 className="projects-heading">Meet Your Coach</h1>
        <p className="projects-subtext">
          Bulletproof Interviewing offers personalized, results-driven coaching from someone who’s
          been on both sides of the interview table.
        </p>
      <div className="about-card">
       

        <p>
          Mark Ambrosio is the coach behind <strong>Bulletproof Interviewing</strong>, where he helps candidates
          navigate and succeed in high-stakes, structured interviews, especially in public safety,
          law enforcement, and security roles. Whether a candidate is aiming for their first position,
          a lateral move, or a promotion, Mark helps them walk in with clarity, confidence, and
          a game plan.
        </p>

        <p>
          With over 17 years of experience in a highly structured, high-accountability public-sector
          environment, Mark began helping friends, colleagues, and peers prepare for interviews by
          breaking down complex questions, practicing real panel formats, and coaching them on how to
          showcase their experience with impact. One by one, they started landing roles, promotions,
          and career breakthroughs.
        </p>

        <p>
          That’s when it clicked, this wasn’t just something he was good at, it was something he
          genuinely cared about. Mark launched Bulletproof Interviewing to help more people
          experience that same success.
        </p>

        <p>
          Backed by a Bachelor’s degree in Speech Communication (now Communication Studies) from
          the University of Waterloo, Mark combines real-world experience with proven communication
          strategies to deliver coaching that’s practical, tailored, and results-driven.
        </p>

        <p>
          He has helped dozens of people go from nervous and unsure to polished, prepared, and hired 
          and would love to help you do the same.
        </p>

        <p>
          <strong>Ready to make your next interview your best one?</strong> Book a free consultation
          or explore his services to get started.
        </p>

        <p className="signature">Mark Ambrosio</p>
      </div>
  <div className="cta">
        
        <p>
          Contact me for a <strong>free consultation</strong> or to ask any questions before
          booking.
        </p>
        <button className="cta-btn" onClick={()=>{
            navigate('/contact')}}>Contact Us</button>
      </div>
    </div>
  );
};

export default Projects;
